export default __webpack_public_path__ + "static/media/rec.db369a54.png";